/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { theme } from '../../styles/theme'
import { useState, useEffect } from 'react'

const backToTopStyles = css`
  position: fixed;
  bottom: 80px;
  right: 20px;
  background: ${theme.colors.primary};
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  opacity: 0.7;
  transition: opacity 0.3s;
  z-index: ${theme.zIndex.backToTop};
  border: none;
  cursor: pointer;
  
  &:hover {
    opacity: 1;
    color: white;
  }
`

export const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', toggleVisibility)
    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  if (!isVisible) return null

  return (
    <button css={backToTopStyles} onClick={scrollToTop} aria-label="Back to top">
      <i className="fas fa-arrow-up"></i>
    </button>
  )
}